import * as yup from "yup";

export const ScholarshipFormValidation =  yup.object().shape({
    id: yup.string().optional(),
    idStudent: yup.string().required(),
    studentCode: yup.string().required("O código do estudante é obrigatório"),
    idScholarshipProvider: yup.string().required("O provedor é obrigatório"),
    idScholarshipType: yup.string().required("O tipo de bolsa é obrigatório"),
    idPaymentType: yup.string().optional(),
    amount: yup.number().min(0, "Valor mínimo 0").optional(),
    startDate: yup.string().required("Data de início é obrigatória"),
    endData: yup.string().required("Data de término é obrigatória"),
    idsPaymentTypes: yup.string().optional(),
    status: yup.boolean().default(true),
    percent: yup.number().required().min(0, "Percentual mínimo 0%").max(100, "Percentual máximo 100%"),
    description: yup.string().optional(),
    idPaymentsPercents: yup
    .array()
    .of(
      yup.object().shape({
        idPaymentType: yup.string().required("Obrigatório"),
        percent: yup
          .number()
          .required("Obrigatório")
          .min(0, "Mínimo 0")
          .max(100, "Máximo 100"),
      })
    )
    .test(
      "unique-payment-type",
      "Não pode haver tipos de pagamento duplicados.",
      (value) => {
        if (!value) return true;
        const ids = value.map((item) => item.idPaymentType);
        const uniqueIds = new Set(ids);
        return uniqueIds.size === ids.length;
      }
    ),
});